<template>
  <b-container class="p-5">
    <div class="text-center">
      <b-img
        :src="appLogoImage"
        alt="logo"
      />
    </div>
    <b-card
      no-body
      class="p-1"
    >
      <b-form-group>
        <b-form-input
          v-model="bulletinSearch"
          placeholder="Buscar boletin"
        />
      </b-form-group>
    </b-card>
    <b-card
      v-for="bulletin in bulletins"
      :key="bulletin.boletinId"
      class="p-1"
    >
      <b-card-header class="border-bottom mb-1">
        <div>
          <b-badge
            v-if="bulletin.nuevo"
            pill
            variant="light-success"
            class="mr-1"
          >
            <strong>Nuevo</strong>
          </b-badge>
          <strong> #{{ bulletin.boletinId }} - {{ bulletin.titulo }}</strong>
          <b-badge
            pill
            variant="light-primary"
            class="ml-1"
          >
            {{ bulletin.fechaHoraCreacion.substring(0, 10) }}
            <!-- {{ bulletin.boletinTipo.nombre }} -->
          </b-badge>
        </div>
        <b-badge
          pill
          variant="light-secondary"
        >
          Categoria: {{ bulletin.boletinTipo.nombre }}
          <!-- {{ bulletin.boletinTipo.nombre }} -->
        </b-badge>
      </b-card-header>
      <b-card-body>
        <div
          v-if="bulletin.readMore"
          v-html="bulletin.contenido"
        />
        <div
          v-if="!bulletin.readMore"
          v-html="`${bulletin.contenido.substring(0, 1000)}...`"
        />
        <b-button
          v-if="bulletin.contenido.length > 1000"
          size="sm"
          variant="outline-primary"
          @click="() => { bulletin.readMore = bulletin.readMore ? false : true}"
        >
          {{ bulletin.readMore === true ? 'Leer menos' : 'Leer mas' }}
        </b-button>
      </b-card-body>
      <span
        v-for="adjunto in bulletin.boletinAdjuntos"
        :key="adjunto.boletinAdjuntoId"
        class="cursor-pointer text-primary d-block"
        @click="downloadFile(adjunto)"
      >
        <feather-icon
          icon="PaperclipIcon"
        />
        <strong>{{ adjunto.archivo }}.{{ adjunto.extension }} </strong>
      </span>
    </b-card>
  </b-container>
</template>

<script>
import {
  BContainer,
  BCard,
  BCardHeader,
  BCardBody,
  BFormGroup,
  BFormInput,
  BBadge,
  BButton,
  BImg,

} from 'bootstrap-vue'
import fileService from '@/services/file.service'
import { saveAs } from 'file-saver'
import bulletinService from '@/services/bulletin.service'
import { ref, watch, set } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BContainer,
    BCard,
    BCardHeader,
    BCardBody,
    BFormGroup,
    BFormInput,
    BBadge,
    BButton,
    BImg,
  },
  setup() {
    const {
      fetchCustomersBulletins,
    } = bulletinService()
    const {
      fetchFile,
    } = fileService()

    const bulletins = ref([])
    const bulletinSearch = ref('')

    const refetch = () => {
      fetchCustomersBulletins({ searchQuery: bulletinSearch.value }, data => {
        bulletins.value = data.boletines
        bulletins.value.forEach(item => {
          const bulletin = item
          set(bulletin, 'readMore', false)
        })
      })
    }

    const downloadFile = item => {
      fetchFile(item.guid, data => {
        const file = new File([data], `${item.archivo}.${item.extension}`)
        saveAs(file, `${item.archivo}.${item.extension}`)
      })
    }
    watch([bulletinSearch], () => {
      refetch()
    })

    const { appLogoImage } = $themeConfig.app
    refetch()
    return {
      bulletins,
      bulletinSearch,
      downloadFile,
      appLogoImage,
    }
  },
}
</script>

<style>

</style>
